import { useQuery, UseQueryResult } from 'react-query';
import { useBrandId, useBrandConfig } from '@ux/whitelabel';
import { useDSTContext } from 'presentation/components/pages/CMPage/DSTContext';
import { getSuggestions } from 'infrastructure/suggestions';
import { DSTApiResponse } from 'presentation/utils/dstApiResponseTypes';

import { DOMAIN_SUGGESTIONS } from '../../queries';

type ResponseType = {
  body: DSTApiResponse;
};

export default function useGetSuggestions(): UseQueryResult<ResponseType> {
  const brandId = useBrandId();
  const config = useBrandConfig();
  const includeTax = config.payment.addTaxToDisplayPrice;
  const query = useDSTContext();
  const { domainName, exactMatch } = query;
  const fetchFn = () => {
    return getSuggestions(query, { brandId, includeTax });
  };

  return useQuery([DOMAIN_SUGGESTIONS, domainName, exactMatch, brandId], fetchFn);
}
